import React from "react";

import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    "& > *:not(:first-child)": {
      marginLeft: theme.spacing(1),
    },
  },
}));

export interface ToolbarProps {
  children: React.ReactNode;
}

export default function Toolbar({ children }: ToolbarProps) {
  const classes = useStyles();

  return (
    <Box
      className={classes.container}
      display="flex"
      displayPrint="none"
      paddingRight={2}
    >
      {children}
    </Box>
  );
}
